<template>
	<v-container>
		<v-row v-if="selectedItems.length > 0"
			   class="d-flex align-center rounded-lg"
			   :style="{background: elementBackgroundColor}">
			<v-col cols="6" class="start">
				<span :style="{ color: elementTextColor }" class="element">
					{{ selectedItems.length }} item(s) selected
				</span>
			</v-col>
			<v-col cols="6" class="end delete">
				<v-btn @click="deleteSelection(selectedItems)"
					   prepend-icon="mdi-delete"
					   variant="outlined"
					   :style="{ color: elementTextColor }"
					   class="delete">DELETE</v-btn>
			</v-col>
		</v-row>
		<v-row justify="start">
			<v-col>
				<v-data-table :headers="headers"
							  :items="loglist"
							  :sort-by="[{ key: 'id', order: 'desc' }]"
							  :items-per-page="15"
							  :items-per-page-options="[
						{ value: 15, title: '15' },
						{ value: 30, title: '30' },
						{ value: 50, title: '50' },
						{ value: 100, title: '100' },
						{ value: 200, title: '200' },
					]"
							  :search="search"
							  loading-text="Loading... Please wait"
							  :hover="true"
							  :multi-sort="false"
							  :show-select="shouldShowSelect"
							  v-model="selectedItems">
					<template v-slot:top>
						<div class="d-flex align-center pa-1 pb-2">
							<span class="blue--text font-weight-medium">Transaction</span>
							<v-spacer></v-spacer>
							<v-text-field class="row align-right"
										  v-model="search"
										  append-icon="mdi-magnify"
										  label="Search"
										  single-line
										  hide-details></v-text-field>
							<v-spacer></v-spacer>
							<v-dialog v-model="dialog" max-width="80%">
								<v-card>
									<v-card-title>
										<span class="ma-0 pa-0">{{ hostFormTitle }}</span>
									</v-card-title>

									<v-card-text>
										<v-container>
											<input type="hidden" v-model="editedItem.id" />
											<v-textarea class="ma-0 pa-0 form-label logMonospace"
														dense
														auto-grow
														readonly
														v-model="editedItem.log">
											</v-textarea>
										</v-container>
									</v-card-text>

									<v-card-actions>
										<v-spacer></v-spacer>
										<v-btn variant="outlined"
											   @click="close">Cancel</v-btn>
									</v-card-actions>
								</v-card>
							</v-dialog>
						</div>
					</template>
					<template v-slot:[`item.action`]="{ item }">
						<v-icon small class="mr-2" @click="editLog(item)">mdi-eye</v-icon>
						<v-icon small @click="deleteLog(item)">mdi-delete</v-icon>
					</template>
					<template v-slot:[`item.reqType`]="{ item }">
						<v-icon v-if="item.reqType == 0"
								icon="mdi-arrow-right-bold"
								center />
						<v-icon v-else icon="mdi-arrow-left-bold" center />
					</template>

					<template v-slot:no-data>
						<span>No Data Available</span>
					</template>
				</v-data-table>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
	import { mapState, mapActions } from "vuex";
	import {
		REMOVE_TRANSACTION,
		LOAD_TRANSACTIONS,
		REMOVE_TRANSACTIONS,
	} from "@/store/_actiontypes";

	export default {
		data: () => ({
			search: "",
			loading: false,
			dialog: false,
			selectedItems: [],
            updateInterval: null, // ADD THIS

			headers: [
                { title: "Id", key: "id", align: " d-none" },
                { title: "Host", key: "hostName" },
				{ title: "Terminal", key: "terminalCode" },
				{ title: "Date", key: "date" },
                { title: "", key: "reqType" },
				{ title: "Msg Type", key: "msgType" },
				{ title: "Transaction Type", key: "transactionType" },
				{ title: "Response Code", key: "responsCode" },
				{ title: "Pan", key: "pan" },
				{ title: "Amount1", key: "amount1" },
				{ title: "Pos Entry", key: "posEntry" },
				{ title: "Actions", key: "action", sortable: false, width: 100 },
			],
			editedItem: {
				id: 0,
				hostId: 0,
				hostName: "",
				terminalId: 0,
				terminalCode: "",
				date: "",
				protocol: 0,
				msgType: "",
				transactionType: "",
				responsCode: "",
				pan: "",
				amount1: "",
				amount2: "",
				posEntry: "",
				log: "",
				jsonLog: "",
                reqType: 0,
			},
			defaultItem: {
				id: 0,
				hostId: 0,
				hostName: "",
				terminalId: 0,
				terminalCode: "",
				date: "",
				protocol: 0,
				msgType: "",
				transactionType: "",
				responsCode: "",
				pan: "",
				amount1: "",
				amount2: "",
				posEntry: "",
				log: "",
				jsonLog: "",
                reqType: 0,
			},
		}),

        mounted() {
            // Start polling when component mounts
            this.startPolling();
        },

        beforeUnmount() {
            // Stop polling when component is destroyed
            this.stopPolling();
        },


		computed: {
			...mapState({ loglist: (state) => state.transactions.transactionlist }),

			hostFormTitle() {
				return "View Transaction";
			},

			shouldShowSelect() {
				return this.loglist.length >= 1;
			},
			elementTextColor() {
				return this.$vuetify.theme.global.name === "dark" ? "white" : "black";
			},
			elementBackgroundColor() {
				return this.$vuetify.theme.global.name === "dark" ? "#3d1924" : "#cfe4f2";
			},
		},

		async created() {
			this.loadData();
		},

		watch: {
			dialog(val) {
				val || this.close();
			},
			selectedItems(val) {
				this.selectedItems = val;
			},
		},

		methods: {
			...mapActions("transactions", [REMOVE_TRANSACTION, REMOVE_TRANSACTIONS]),

			startPolling(intervalMs = 5000) {
                // Start immediate fetch
                this.loadData();

                // Then poll every 5 seconds (or your preferred interval)
                this.updateInterval = setInterval(() => {
                    this.loadData();
                }, intervalMs);
            },
            stopPolling() {
                if (this.updateInterval) {
                    clearInterval(this.updateInterval);
                    this.updateInterval = null;
                }
            },

			async loadData() {
				//this.loading = true;
				await this.$store.dispatch(`transactions/${LOAD_TRANSACTIONS}`);
				//this.loading = false;
			},

			editLog(item) {
				this.editedItem = Object.assign({}, item);
				this.dialog = true;
			},

			deleteLog(item) {
				if (confirm("Are you sure you want to delete this transaction?")) {
					this.REMOVE_TRANSACTION({ id: item.id });
				}
			},

			deleteSelection() {
				const ids = [];
				for (var val in this.selectedItems) {
					ids.push(this.selectedItems[val]);
				}
				if (
					confirm(
						`Are you sure you want to delete ${ids.length} selected item(s)?`
					)
				) {
					this.REMOVE_TRANSACTIONS({ ids: ids });
					this.selectedItems = [];
				}
			},

			close() {
				this.dialog = false;
				this.editedItem = Object.assign({}, this.defaultItem);
			},
		},
	};
</script>

<style>
	.logMonospace {
		font-family: monospace;
		font-size: 14px;
		line-height: 1.5;
	}

	.element {
		padding: 10px;
		border: none;
		color: black;
	}

	.start {
		display: flex;
		justify-content: flex-start;
	}

	.end {
		display: flex;
		justify-content: flex-end;
		align-items: align-center;
	}

	.delete {
		cursor: pointer;
	}
</style>